"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pordenone": {
    "10a18af5": [{
      "hkey": "ba636dcc",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "ba636dcc",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pordenone"
    }],
    "544d7424": [{
      "hkey": "89fe5221",
      "slug": "vallenoncello",
      "name": "Vallenoncello",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "5f3f166a",
      "slug": "pordenone-nord",
      "name": "Pordenone Nord",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "5f3f166a",
      "slug": "pordenone-nord",
      "name": "Pordenone Nord",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pordenone"
    }],
    "6e5c1566": [{
      "hkey": "e5691155",
      "slug": "rorai-grande-grigoletti",
      "name": "Rorai Grande-Grigoletti",
      "primary": true,
      "skipSearch": false
    }],
    "roraigrande": [{
      "hkey": "e5691155",
      "slug": "rorai-grande-grigoletti",
      "name": "Rorai Grande-Grigoletti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b45d02b8": [{
      "hkey": "e5691155",
      "slug": "rorai-grande-grigoletti",
      "name": "Rorai Grande-Grigoletti",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d1f9a025",
      "slug": "san-valentino-ospedale",
      "name": "San Valentino-Ospedale",
      "primary": false,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "e5691155",
      "slug": "rorai-grande-grigoletti",
      "name": "Rorai Grande-Grigoletti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pordenone"
    }],
    "068ea6cc": [{
      "hkey": "9dab4127",
      "slug": "san-gregorio-villanova",
      "name": "San Gregorio-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "villanova": [{
      "hkey": "9dab4127",
      "slug": "san-gregorio-villanova",
      "name": "San Gregorio-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;